import React, { useState, useEffect, useContext } from "react";
import Table from "../../../components/Table";
import { LuWorkflow } from "react-icons/lu";
import { FeatureFlowColumns } from "./featureColumns";
import Modal from "../../../components/Modal";
import FeatureFields from "../../../components/Multiselect/FeatureFields";
import { makeApiCall } from "../../../config";
import { successToaster, ErrorToaster } from "../../../utils/toaster";
import AuthContext from "../../../context/AuthContext";
import FeatureView from "../../../components/FeatureView";
import FeatureFlowChart from "./FeatureFlowChart";
import { IoIosCloseCircleOutline, IoMdAdd, IoMdClose, IoMdRemove } from "react-icons/io";
import { TiTickOutline } from "react-icons/ti";
import Error from "../../../components/Error";
import Loader from "../../../components/Loader";
import SpinnerBtn from "../../../components/SpinnerBtn";



export default function FeatureFlow() {
  const [enablePopup, setEnablePopup] = useState(false);
  const [spinnerBtn, setSpinnerBtn] = useState({
    createBtn: false,
    featureFlowBtn: false
  });

  const [enableChart, setEnableChart] = useState(false);
  const [nodes, setNodes] = useState(false);
  const [edges, setEdges] = useState(false);
  const [focus, setFocus] = useState(false);
  const { userInfo, enableToaster, getUserInfo } = useContext(AuthContext);
  const [intiFeatureFields, setInitFeatureFields] = useState({});
  const [featureFields, setFeatureFields] = useState([]);
  const [featureResult, setFeatureResult] = useState({
    eventList:[]
  });
  const [featurePages, setFeaturePages] = useState(null)
  const [allFeature,setAllFeature] = useState([]);
  const [featurePageEvents, setFeaturePageEvents] = useState(null);
  const [enableLoader, setEnableLoader] = useState(false);

  const time = new Date();

  const handleAllModalEvents = (key, value, index, id) => {
    if (key === "pageLists") {
      const existingItemIndex = featureResult?.eventList?.findIndex((exItem) => exItem.id === index);
      
      if (existingItemIndex === -1) {
        setFeatureResult((prevFeatureResult) => ({
          ...prevFeatureResult,
          eventList: [
            ...prevFeatureResult.eventList,
            {
              id: index,
              [key]: value,
            },
          ],
        }));
      } else {
        setFeatureResult((prevFeatureResult) => {
          const updatedEventList = [...prevFeatureResult.eventList];
          const existingItem = updatedEventList.find((item) => item.id === index);
  
          if (existingItem) {
            existingItem[key] = value;
          } else {
            updatedEventList.push({ id: index, [key]: value });
          }
  
          return {
            ...prevFeatureResult,
            eventList: updatedEventList,
          };
        });
      }
    } else if (key === "title") {
      setFeatureResult((prev) => ({
        ...prev,
        created_at: time,
        [key]: value,
      }));
    }else if(key === "page"){
      setFeatureResult((prevFeatureResult) => {
        const updatedEventList = [...prevFeatureResult.eventList];
        const existingItem = updatedEventList.find((item) => item.id === index);

        if (existingItem) {
          existingItem.pageName = value;
          existingItem.routeId = id;
        } else {
          updatedEventList.push({ id: index, routeId: id, pageName: value});
        }
        return {
          ...prevFeatureResult,
          eventList: updatedEventList,
        };
      });
     console.log("final result ", featureResult); 
    }
  };

  async function getEventLists(param) {
    setSpinnerBtn({
      ...spinnerBtn,
      createBtn: true
    });
    try {
      if (param._id && param.defaultURL) {
        const response = await makeApiCall(
          "/api/v1/admin/get/pageEvents",
          "get",
          null,
          { userId: param._id, hostname: param.defaultURL }
        );
        console.log("getEventLists :", response);
        setFeatureFields([response?.data]);
        setInitFeatureFields(response?.data);
        enableToaster && successToaster(response.message);
        setEnablePopup(true);
        setSpinnerBtn({
          ...spinnerBtn,
          createBtn: false
        });
        return;
      }
    } catch (error) {
      ErrorToaster("something went wrong");
      console.log("error occurred in getEventLists", error);
      setEnablePopup(false);
      setSpinnerBtn({
        ...spinnerBtn,
        createBtn: false
      });
    }
  }

  async function getAllFeatures(param) {
    try {
      const response = await makeApiCall(
        "/api/v1/admin/get/feature",
        "get",
        null,
        { userId: param._id, hostname: param.defaultURL }
      );
      setAllFeature(response.data);
      enableToaster && successToaster(response.message);
      setEnableLoader(false);
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        console.log("error occurred in getAllFeatures", error);
      }
      setEnableLoader(false);
    }
  }
  useEffect(() => {
    setEnableLoader(true);
    (async()=>{
      const userData = await getUserInfo();
      if (userData) {
        await getAllFeatures(userData);
      }

    })()
  }, [focus]);

  const handleAddClick = () => {
    setFeatureFields([...featureFields, intiFeatureFields]);
  };

  const handleRemoveClick = (index) => {
    const remove = featureFields.filter(
      (_, indexFilter) => !(indexFilter === index)
    );
    setFeatureFields(remove);
    return;
  };

  const handleSaveModal = async () => {
    try {
      featureResult.hostname = userInfo.defaultURL;
      const response = await makeApiCall("/api/v1/admin/add/feature", 'post', featureResult , {userId: userInfo._id});
      successToaster(response.message);
      setEnablePopup(false);
      setFocus(!focus);
      return;
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        console.log("Error occurred in Save Feature", error);
      }
    }
  };
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    if (name === 'title') {
      return handleAllModalEvents("title", value);
      
    }
    if (name === 'feature-type') {
      setFeatureResult((prev) => ({
        ...prev,
        ['type']: value,
      }));
    }
  };

  const handleGetFeatureEvents = (params)=>{
    setFeaturePages(params.original);
  }

  const handleGetFeaturePages = (params) =>{
    setFeaturePageEvents(params.original.pageLists)
  }

  async function getFeatureFlows() {
    setSpinnerBtn({
      ...spinnerBtn,
      featureFlowBtn: true
    });
    try {
      const res = await makeApiCall("/api/v1/admin/get/feature/flow", "get", null, {userId: userInfo._id});
      setNodes(res?.data?.allNodes);
      setEdges(res?.data?.edgesArray);
      setEnableChart(true);
      enableToaster && successToaster(res.message);
      setSpinnerBtn({
        ...spinnerBtn,
        featureFlowBtn: false
      });
      return;
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        console.log("Error occurred in get feature flow", error);
      }
      setEnableChart(false);
      setSpinnerBtn({
        ...spinnerBtn,
        featureFlowBtn: false
      });
    }
  }
  
  return (
    <>
      <Modal
        enable={enablePopup}
        handleSave={() => handleSaveModal()}
        handleCancel={() => setEnablePopup(false)}
        handleAddClick={()=> handleAddClick()}
        title={"Create Feature"}
        label={<div className="flex ml-5">
              <div className="w-[45%] flex flex-col">  
                <h2 className="text-gray-900 py-3 font-semibold dark:text-white text-justify pb-4">
                      {'Feature Name'}
                </h2>
                <input
                  className="w-[100%] field-focus max-w-[50%] dark:bg-navy-700"
                  type="text"
                  name={"title"}
                  onChange={(e) => handleOnChange(e)}
                  placeholder="Enter feature title"
                  id="feature-title"
                />
              </div>
              <div className="w-[45%] flex flex-col">
                <h3 className="text-gray-900 py-3 font-semibold dark:text-white text-justify">
                  {'Feature Label'}
                </h3>
                <div className="flex my-2 text-xl"
                
                >
                    <div className="flex items-center">
                        <input id="free-radio" type="radio" value="free" onChange={handleOnChange} name="feature-type" className="w-4 h-4 bg-gray-100 border-gray-300 dark:border-gray-600"/>
                        <label for="red-radio" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Free</label>
                    </div>
                    <div className="flex items-center ml-4">
                        <input id="paid-radio" type="radio" value="paid" onChange={handleOnChange} name="feature-type" className="w-4 h-4 bg-gray-100 border-gray-300 dark:border-gray-600"/>
                        <label for="green-radio" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Paid</label>
                    </div>
                </div>
              </div>
            
        </div>}
        content={
          <>
            {featureFields.length != 0 &&
              featureFields.map((feature, i) => (
                <div key={i} className=" w-[100%] flex justify-between">
                  <div className="border-b-orange-400">
                    <FeatureFields
                      featureData={feature}
                      handleAllModalEvents={handleAllModalEvents}
                      featureResult={featureResult}
                      index={i}
                    />
                  </div>
                  <div className=" flex justify-end gap-3">
                    {featureFields.length - 1 === i && (
                      <IoMdAdd
                        className=" text-lg icon-border"
                        onClick={() => handleAddClick()}
                      />
                    )}
                    {featureFields.length !== 1 && (
                      <IoMdRemove
                        className=" text-lg icon-border"
                        onClick={() => handleRemoveClick(i)}
                      />
                    )}
                  </div>
                </div>
              ))}
          </>
        }
      />

     <div className="m-3 float-right flex">
        {!spinnerBtn.createBtn ? <button
          type="button"
          onClick={async() => {
            await getEventLists(userInfo);
           
          }}
          className="me-2 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 inline-flex items-center focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          <IoMdAdd className=" font-bold w-3.5 h-3.5 me-2" />
          Create{" "}
        </button> : <SpinnerBtn style={"me-2 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 inline-flex items-center focus-visible:outline-offset-2 focus-visible:outline-indigo-600"}/>}
        {!spinnerBtn.featureFlowBtn ? <div
          
          
          className="me-2 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 inline-flex items-center focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          <LuWorkflow className=" font-bold w-3.5 h-3.5 me-2" />
          {enableChart ? <span className=" cursor-pointer" onClick={()=> setEnableChart(!enableChart)} >Close</span> :<span className="cursor-pointer" onClick={async() => getFeatureFlows()}>Feature Flow</span>}
        </div> : <SpinnerBtn style={"me-2 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 inline-flex items-center focus-visible:outline-offset-2 focus-visible:outline-indigo-600"}/>}
      </div>
     { !enableChart && allFeature.length != 0 && !featurePages &&  (
     <Table
        tableData={allFeature}
        columns={FeatureFlowColumns}
        title={"All Feature"}
        onUserClick={handleGetFeatureEvents}
      />
      )}
    {!enableChart && featurePages && !featurePageEvents && (<FeatureView
            params={featurePages}
            handleBackBtn={setFeaturePages}
            onUserClick={handleGetFeaturePages}
          />)}
    {/* {featurePageEvents && (<Table
            tableData={featurePageEvents}
            columns={FeaturePageEventsColumns}
            handleBackBtn={setFeaturePageEvents}
            title={"All Pages"}
          />)} */}
      {enableChart && <FeatureFlowChart nodesData={nodes} edgesData={edges}/>}
      {enableLoader && <Loader/>}
      {!enableLoader && allFeature.length === 0 && <Error/>}
    </>
  );
}
